export * from './new.corporate.details.component'



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/dashboard/app/modules/customers/+applications/new/detail/+details/corporate/index.ts